import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

export default function Testimonials({ items }) {
  if (!items?.length) return null;
  return (
    <section id="reviews" className="max-w-7xl mx-auto px-6 py-20 lg:py-24" data-testid="testimonials-section">
      <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-[#FF5A1F]" data-testid="testimonials-eyebrow">Buyer Reviews</p>
      <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-extrabold tracking-tight max-w-2xl" data-testid="testimonials-heading">
        Trusted by brands, clubs & businesses
      </h2>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((t, i) => (
          <motion.blockquote key={t.id}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
            className="bg-[#161B22] border border-white/10 rounded-2xl p-8 flex flex-col hover:border-[#FF5A1F]/40 transition-colors"
            data-testid={`testimonial-card-${t.id}`}>
            <Quote size={26} className="text-[#FF5A1F]/40" />
            <div className="mt-4 flex gap-1" data-testid={`testimonial-stars-${t.id}`}>
              {Array.from({ length: Math.max(1, Math.min(5, t.rating || 5)) }).map((_, s) => (
                <Star key={s} size={16} className="text-[#FFB800] fill-[#FFB800]" />
              ))}
            </div>
            <p className="mt-4 text-sm sm:text-base text-slate-300 leading-relaxed flex-1">"{t.text}"</p>
            <footer className="mt-6">
              <p className="font-heading font-bold text-sm">{t.name}</p>
              <p className="text-xs text-slate-400 mt-0.5">{t.company}</p>
            </footer>
          </motion.blockquote>
        ))}
      </div>
    </section>
  );
}
